"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8891%3A790))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.633Z
 */
export const Slovenia = createSVGIcon(
  <>
    <rect x="1" y="1" width="16" height="12" fill="#B64343" />
    <rect x="1" y="1" width="6" height="12" fill="#64804E" />
    <rect x="1" y="1" width="16" height="12" stroke="#757575" />
    <circle cx="6.5" cy="6.5" r="3" fill="#B64343" stroke="#FFD464" />
    <path
      d="M8 7C8 7.55228 7.32843 8 6.5 8C5.67157 8 5 7.55228 5 7V5H8V7Z"
      fill="white"
    />
    <g clipPath="url(#clip0_8891_790)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 1V13H17V1H1Z"
        fill="#2E42A5"
      />
      <mask
        id="mask0_8891_790"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 1V13H17V1H1Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_8891_790)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 1V5H17V1H1Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 9V13H17V9H1Z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.86996 3.518C7.86996 3.518 6.81796 3.021 5.50896 3.021C4.19996 3.021 3.14746 3.518 3.14746 3.518C3.14746 3.518 3.26446 5.5155 3.44996 6.5735C3.52896 7.0255 3.90846 7.6845 4.25246 7.996C4.64446 8.3515 5.50896 8.773 5.50896 8.773C5.75896 8.6005 6.22646 8.523 6.82396 7.9965C7.42196 7.4695 7.57046 6.5735 7.57046 6.5735L7.87046 3.5185L7.86996 3.518Z"
          fill="#2E42A5"
        />
        <path
          d="M7.73086 3.453L8.16936 3.6715L7.86836 6.683C7.76336 7.3205 7.49936 7.823 7.07736 8.1945C6.86749 8.38141 6.63541 8.54178 6.38636 8.672C6.25136 8.7425 5.68636 9.0335 5.69136 9.0315C5.63436 9.0585 5.59136 9.0825 5.55636 9.1065L5.50136 9.144L5.44286 9.1155C4.85786 8.8305 4.31136 8.4465 4.03986 8.2005C3.66936 7.8645 3.27886 7.1765 3.19536 6.7005C3.07086 5.989 2.95936 5.0085 2.88086 3.6715L3.27436 3.466C3.35236 4.7925 3.44636 5.85 3.56836 6.5485C3.64086 6.9625 4.00086 7.5965 4.32986 7.8945C4.57236 8.1145 4.96386 8.3585 5.50186 8.6245C5.53713 8.60385 5.57334 8.58483 5.61036 8.5675C5.61136 8.567 5.97736 8.404 6.10436 8.3375C6.33648 8.21637 6.55278 8.06707 6.74836 7.893C7.12236 7.563 7.35636 7.119 7.45086 6.5545L7.73086 3.453Z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.771 6.512C3.771 6.512 3.866 6.804 4.0425 7.132C4.3015 7.2 4.46 7.1965 4.5105 7.1405C4.6555 6.9785 5.1705 6.909 5.267 7.0475C5.326 7.1325 5.535 7.1925 5.763 7.114L5.7375 7.1185C5.7775 7.104 5.86999 7.067 5.92749 7.0445L5.97349 7.026C6.05949 6.994 6.12249 6.977 6.18699 6.972C6.26986 6.96613 6.35276 6.98271 6.42699 7.02C6.60649 7.1055 6.82849 7.1455 6.97999 7.12C7.16499 6.7975 7.29649 6.512 7.29649 6.512L6.419 5.67L6.07 6.0485L5.48999 5.222L5.005 6.0485L4.633 5.67L3.771 6.512ZM4.2785 7.507C4.23809 7.45261 4.19973 7.39674 4.1635 7.3395C4.3885 7.3805 4.5405 7.359 4.6255 7.264C4.6655 7.219 4.7845 7.1755 4.92 7.1575C4.97626 7.14914 5.03326 7.14696 5.09 7.151C5.111 7.153 5.1285 7.156 5.14 7.1605C5.14349 7.1615 5.14349 7.1615 5.14 7.156L5.139 7.155C5.2425 7.303 5.52349 7.382 5.78849 7.286L5.763 7.2905C5.84621 7.26261 5.92858 7.23226 6.01 7.1995L6.02599 7.193C6.08085 7.16975 6.13878 7.15459 6.19799 7.148C6.25473 7.14425 6.31142 7.156 6.36199 7.182C6.52084 7.25799 6.69396 7.29957 6.86999 7.304C6.83499 7.3605 6.79949 7.416 6.76249 7.4705C6.63549 7.5005 6.43949 7.4615 6.281 7.375C6.21493 7.33654 6.13872 7.3191 6.06249 7.325C5.99621 7.33259 5.93166 7.35117 5.8715 7.38L5.82999 7.399C5.77999 7.422 5.7 7.4585 5.6655 7.4725L5.69449 7.467C5.49599 7.5435 5.32249 7.487 5.27299 7.405C5.18449 7.259 4.7215 7.3305 4.591 7.498C4.556 7.5425 4.451 7.55 4.2785 7.507ZM4.451 7.712L4.4805 7.7415C4.932 8.1815 5.4905 8.3975 5.4905 8.3975C5.4905 8.3975 6.15549 8.1965 6.53249 7.7725C6.56499 7.7365 6.59749 7.6975 6.629 7.656C6.48165 7.64605 6.33828 7.60389 6.209 7.5325C6.16865 7.50841 6.12184 7.49741 6.07499 7.501C6.0248 7.50762 5.976 7.52231 5.9305 7.5445L5.919 7.5495C5.8805 7.567 5.76399 7.6195 5.69399 7.6435L5.723 7.6375C5.4895 7.735 5.24149 7.658 5.14449 7.5125C5.13189 7.50807 5.1188 7.50521 5.1055 7.504C5.0576 7.50001 5.00939 7.50203 4.962 7.51C4.847 7.5275 4.747 7.57 4.7135 7.6125C4.658 7.684 4.5705 7.7155 4.451 7.712Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.57367 3.943H4.22217L4.49467 3.688L4.22217 3.418H4.57367L4.72217 3.156L4.87117 3.418H5.22217L4.96317 3.6715L5.19317 3.943H4.87117L4.72217 4.2195L4.57367 3.943ZM6.23017 3.943H5.87917L6.15167 3.688L5.87917 3.418H6.23067L6.37917 3.156L6.52817 3.418H6.87917L6.62017 3.6715L6.85017 3.943H6.52817L6.37917 4.2195L6.23067 3.943H6.23017ZM5.30017 4.7835H4.94867L5.22117 4.5285L4.94867 4.2585H5.30017L5.44867 3.9965L5.59767 4.2585H5.94867L5.68967 4.512L5.91967 4.7835H5.59767L5.44867 5.06L5.30017 4.7835Z"
          fill="#FECA00"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_8891_790">
        <rect width="16" height="12" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </>,
  "Slovenia",
  { fill: "none", viewBox: "0 0 18 14" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
